import {useCallback, useContext} from 'react';

import {ValidationContext} from 'src/contexts/validation-context';

import {
    ADVERTISEMENT_DISPLAY_TIME_CONTROL,
    ADVERTISEMENT_DISPLAY_TIME_REQUIRED_ERROR,
    ADVERTISEMENT_DISPLAY_TIME_REQUIRED_MESSAGE,

    ADVERTISEMENT_IMAGE_CONTROL,
    ADVERTISEMENT_IMAGE_REQUIRED_ERROR,
    ADVERTISEMENT_IMAGE_REQUIRED_MESSAGE,

    ADVERTISEMENT_URL_CONTROL,
    ADVERTISEMENT_URL_REQUIRED_ERROR,
    ADVERTISEMENT_URL_REQUIRED_MESSAGE,
} from '../constants';

import type {AdvertisementsSettings} from 'src/openapi/admin/models/AdvertisementsSettings';

type Data = {
    image: File | null,
} & AdvertisementsSettings;

export const useValidateAdvertisement = () => {
    const {addError, removeError} = useContext(ValidationContext);

    const editValidation = useCallback(({type, link, showingTime, image}: Data) => {
        const fields = [link, showingTime, image];
        const configured = fields.some(Boolean);

        if (image || !configured) {
            removeError(`${type}-${ADVERTISEMENT_IMAGE_CONTROL}`);
        }

        if (link || !configured) {
            removeError(`${type}-${ADVERTISEMENT_URL_CONTROL}`);
        }

        if (showingTime || !configured) {
            removeError(`${type}-${ADVERTISEMENT_DISPLAY_TIME_CONTROL}`);
        }
    }, [removeError]);

    const saveValidation = useCallback(({type, link, showingTime, image}: Data) => {
        let valid = true;
        const fields = [link, showingTime, image];
        const configured = fields.some(Boolean);

        if (configured && !image) {
            addError({
                controlId: `${type}-${ADVERTISEMENT_IMAGE_CONTROL}`,
                code: ADVERTISEMENT_IMAGE_REQUIRED_ERROR,
                message: ADVERTISEMENT_IMAGE_REQUIRED_MESSAGE,
            });
            valid = false;
        } else {
            removeError(`${type}-${ADVERTISEMENT_IMAGE_CONTROL}`);
        }

        if (configured && !link) {
            addError({
                controlId: `${type}-${ADVERTISEMENT_URL_CONTROL}`,
                code: ADVERTISEMENT_URL_REQUIRED_ERROR,
                message: ADVERTISEMENT_URL_REQUIRED_MESSAGE,
            });
            valid = false;
        } else {
            removeError(`${type}-${ADVERTISEMENT_URL_CONTROL}`);
        }

        if (configured && !showingTime) {
            addError({
                controlId: `${type}-${ADVERTISEMENT_DISPLAY_TIME_CONTROL}`,
                code: ADVERTISEMENT_DISPLAY_TIME_REQUIRED_ERROR,
                message: ADVERTISEMENT_DISPLAY_TIME_REQUIRED_MESSAGE,
            });
            valid = false;
        } else {
            removeError(`${type}-${ADVERTISEMENT_DISPLAY_TIME_CONTROL}`);
        }

        return valid;
    }, [removeError, addError]);

    return ({editValidation, saveValidation});
};
